import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import abbreviateNumber from 'flarum/common/utils/abbreviateNumber';

/**
 * The stats strip shown under the user's bio: post count, discussion count and
 * — when fof/follow-users is installed — follower count.
 *
 * Counts that the API did not send are skipped entirely rather than rendered as
 * zero, so an uninstalled extension leaves no empty box behind.
 */
export default class ProfileStats extends Component {
  view() {
    const items = this.items();

    if (!items.length) return null;

    return <div className="ProfileRedesign-stats">{items}</div>;
  }

  items() {
    const user = this.attrs.user;
    const items = [];

    const commentCount = user.commentCount();
    if (typeof commentCount === 'number') {
      items.push(
        this.stat('posts', commentCount, app.translator.trans('happydigital-profile-redesign.forum.stats.posts'), app.route('user.posts', {
          username: user.slug(),
        }))
      );
    }

    const discussionCount = user.discussionCount();
    if (typeof discussionCount === 'number') {
      items.push(
        this.stat(
          'discussions',
          discussionCount,
          app.translator.trans('happydigital-profile-redesign.forum.stats.discussions'),
          app.route('user.discussions', { username: user.slug() })
        )
      );
    }

    // ianm/follow-users is optional; it registers `followerCount` on the User
    // model. Only render when it actually sent a count.
    const followerCount = typeof user.followerCount === 'function' ? user.followerCount() : undefined;
    if (typeof followerCount === 'number') {
      items.push(
        this.stat(
          'followers',
          followerCount,
          app.translator.trans('happydigital-profile-redesign.forum.stats.followers'),
          app.route('user.followers', { username: user.slug() })
        )
      );
    }

    // clarkwinkelmann/likes-received exposes `likesReceived`, but only when the
    // viewer holds its `viewLikesReceived` permission — so an absent value means
    // "not allowed to see", not zero, and the box is left out entirely.
    const likesReceived = user.attribute('likesReceived');
    if (Number.isInteger(likesReceived)) {
      items.push(
        this.stat('likes', likesReceived, app.translator.trans('happydigital-profile-redesign.forum.stats.likes'))
      );
    }

    return items;
  }

  /**
   * A single stat box. Rendered as a link when a route is given so the numbers
   * behave like the navigation they mirror.
   */
  stat(key, value, label, href) {
    const inner = [
      <strong className="ProfileRedesign-stat-value">{abbreviateNumber(value)}</strong>,
      <span className="ProfileRedesign-stat-label">{label}</span>,
    ];

    if (href) {
      return (
        <Link className="ProfileRedesign-stat" key={key} href={href}>
          {inner}
        </Link>
      );
    }

    return (
      <div className="ProfileRedesign-stat" key={key}>
        {inner}
      </div>
    );
  }
}
